<template lang="pug">
.events--information-recommends(v-if="events.length > 0")
  h2.events--title 近くで予定されてるボードゲーム会
  .events--result-list.list--events
    .list--events-item(v-for="event in events")
      .list--events-item-status(:class="event.status_html_class")
        .list--events-item-status-schedule
          .list--events-item-status-schedule-stock
            .list--events-item-status-schedule-stock-icon(:class="event.status_html_class" v-html="event.capacity_status_text")
          .list--events-item-status-schedule-date(v-if="event.starts_at")
            .list--events-item-status-schedule-date-day(v-html="event.starts_date")
            .list--events-item-status-schedule-date-wday(
              :class="[event.starts_wday_class, event.status_html_class]"
            ) <span>{{event.starts_wday}}</span>曜日
            .list--events-item-status-schedule-date-time {{event.starts_time}}～{{event.ends_time}}
        .list--events-item-status-users
          .list--events-item-status-users-participants
            i.fa.fa-users.font-awesome-icon
            | {{event.participants_size}}
          .list--events-item-status-users-interested
            i.fa.fa-stars.font-awesome-icon
            | {{event.interested_members_count}}

      .list--events-item-data(:class="event.main_image_html_class" :style="event.main_image_style")
        .list--events-item-data-wrapper(:class="[event.main_image_html_class, event.status_html_class]")
          .list--events-item-data-organizer
            img(
              :src="event.user.publish_image_url"
              :alt="event.user.nickname"
              width="100"
              height="100"
            )
            img.community(
              v-if="event.organized_by_community"
              :src="event.organizer.image_logo_user_small"
              :alt="event.organizer.name"
              width="100"
              height="100"
            )

          .list--events-item-data-description
            .list--events-item-data-description-title
              a(:class="event.main_image_html_class" :href="event.show_path") {{event.title}}

            .list--events-item-data-description-summary
              .list--events-item-data-description-summary-wrapper
                .list--events-item-data-description-summary-icon.online(v-if="event.is_online")
                  i.fa.fa-globe.font-awesome-icon
                  | オンライン
                .list--events-item-data-description-summary-icon.online(v-if="event.exist_online_tools")
                  i.fa.fa-network-wired.font-awesome-icon
                  | {{event.online_tools}}
                .list--events-item-data-description-summary-icon.location(v-if="!event.is_online && event.prefecture_name")
                  i.fa.fa-map-marker.font-awesome-icon
                  | {{event.prefecture_name}}
                .list--events-item-data-description-summary-icon.location(v-if="!event.is_online && event.venue")
                  i.fa.fa-map-signs.font-awesome-icon
                  | {{event.venue}}
                .list--events-item-data-description-summary-icon.option(v-if="event.anyuser_allowed_to_participate")
                  i.fa.fa-user-check.font-awesome-icon
                  | 誰でも参加
                .list--events-item-data-description-summary-icon.option(v-if="event.attendant_allowed_to_participate")
                  i.fa.fa-users-medical.font-awesome-icon
                  | 連れ添い登録
                .list--events-item-data-description-summary-icon.option(v-if="event.need_to_join_organizer")
                  i.fa.fa-check.font-awesome-icon
                  | 要コミュニティ登録

            .list--events-item-data-description-overview
              p {{event.truncated_body}}
            ul.list--events-item-data-description-tags
              li(v-if="event.prefecture")
                a(
                  :href="event.prefecture_search_path"
                  :class="event.main_image_html_class"
                )
                  | {{"#"}}{{event.prefecture_name}}のボードゲーム会 
              li(v-for="tag in event.tags")
                a(
                  :href="tag.search_path"
                  :class="event.main_image_html_class"
                )
                  | {{"#"}}{{tag.name}}
</template>

<script>
export default {
  props: {
    currentEvent: {
      type: Object,
      default: null
    },
    events: {
      type: Array,
      default: () => ([])
    }
  },
  methods: {
    itemStyle: function(path) {
      return 'background-image: url("' + path + '")';
    },
    event_path: function(event) {
      return '/events/' + event.id;
    }
  }
};
</script>
